import React from 'react';
import { Tooltip } from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';
import { useAuthenticatedContext } from '../../../../container';
import { ApplicationEntryEnhancer, OrganizationRouteEnhancer } from '../../../entrypoint';
import { useFeatureApi } from '../../../app';

export function createFeatureMultiAssetStrategy(): ApplicationEntryEnhancer {
    return (create) => (config) => {
        return create({
            ...config,
            module: {
                ...config.module,
                createWorkspaceSelectionModule(moduleConfig) {
                    return config.module.createWorkspaceSelectionModule({
                        ...moduleConfig,
                        provider: {
                            ...moduleConfig.provider,
                            createController(controllerConfig) {
                                const controller =
                                    moduleConfig.provider.createController(
                                        controllerConfig
                                    );
                                return {
                                    useProps(context) {
                                        const mapped = controller.useProps(context);
                                        const appcontext = useAuthenticatedContext();
                                        const api = useFeatureApi();
                                        const featureset = api.getFeatureset();
                                        const response = appcontext.access.canAccess({
                                            ...featureset.multi_assets!,
                                            value: null,
                                        });
                                        return {
                                            ...mapped,
                                            getAddButtonProps() {
                                                if (response.restricted) {
                                                    return {
                                                        ...mapped.getAddButtonProps?.(),
                                                        allowClickWhenDisabled: true,
                                                        disabled: true,
                                                        tooltipProps: {
                                                            label: 'Upgrade for multiple assets',
                                                        },
                                                        onClick: api.restrictClick(
                                                            featureset.multi_assets!
                                                        ),
                                                    };
                                                }
                                                return mapped.getAddButtonProps?.() ?? {};
                                            },
                                            getItemProps(workspace, index) {
                                                const original = mapped.getItemProps?.(
                                                    workspace,
                                                    index
                                                );
                                                if (response.restricted && index > 0) {
                                                    return {
                                                        ...original,
                                                        disabled: true,
                                                        allowClickWhenDisabled: true,
                                                        rightSection: (
                                                            <Tooltip label="Upgrade for multiple assets">
                                                                <LockIcon />
                                                            </Tooltip>
                                                        ),
                                                        onClick: api.restrictClick(
                                                            featureset.multi_assets!
                                                        ),
                                                    };
                                                }

                                                return (
                                                    mapped.getItemProps?.(
                                                        workspace,
                                                        index
                                                    ) ?? {}
                                                );
                                            },
                                        };
                                    },
                                };
                            },
                        },
                    });
                },
            },
            // controller: {
            //     ...config.controller,
            //     workspaceSelection: {
            //         useProps() {
            //             const context = useAuthenticatedContext();
            //             const mapped = config.controller.workspaceSelection.useProps();
            //             const api = useFeatureApi();
            //             const featureset = api.getFeatureset();
            //             const response = context.access.canAccess({
            //                 ...featureset.multi_assets,
            //                 value: null,
            //             });
            //             return {
            //                 ...mapped,
            //                 getAddButtonProps() {
            //                     if (response.restricted) {
            //                         return {
            //                             ...mapped.getAddButtonProps?.(),
            //                             allowClickWhenDisabled: true,
            //                             disabled: true,
            //                             tooltipProps: {
            //                                 label: 'Upgrade for multiple assets',
            //                             },
            //                             onClick: api.restrictClick(
            //                                 featureset.multi_assets
            //                             ),
            //                         };
            //                     }
            //                     return mapped.getAddButtonProps?.() ?? {};
            //                 },
            //                 getItemProps(workspace, index) {
            //                     if (response.restricted && index > 0) {
            //                         return {
            //                             ...mapped.getItemProps?.(workspace, index),
            //                             rightSection: (
            //                                 <Tooltip label="Upgrade for multiple assets">
            //                                     <LockIcon />
            //                                 </Tooltip>
            //                             ),
            //                             onClick: api.restrictClick(
            //                                 featureset.multi_assets
            //                             ),
            //                         };
            //                     }

            //                     return mapped.getItemProps?.(workspace, index) ?? {};
            //                 },
            //             };
            //         },
            //     },
            // },
        });
    };
}
